module.exports = __webpack_public_path__ + "img/feature_buy_zh.c7ef7f9a.png";